// 通讯录
import Incubator from './IncubatorList';
import ProjectOpen from './PageOpen';

const router = {
  path: 'project',
  breadcrumbName: '项目管理',
  childRoutes: [
    {
      path: 'incubator/:model',
      breadcrumbName: '孵化器',
      indexRoute: { component: Incubator },
      childRoutes: [],
    },
    {
      path: 'open/:model/:id',
      component: ProjectOpen,
      breadcrumbName: '项目详情',
    },
  ],
};

export default router;



// WEBPACK FOOTER //
// ./src/components/project/router.js